export const ANALYTICS_SHORTCUT_PRESSED = 'arjKeyboardShortcut pressed';
